import React, { Component } from 'react';
import { Grid, Input, Button, Form, TextArea, Dropdown } from 'semantic-ui-react';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';

class Edit extends Component {

  state = {
    section_name: this.props.section_name,
    tamil_name: this.props.tamil_name,
    status: this.props.status,
    id: this.props.id,
    data: this.props.data,
    priority: this.props.priority,
    load: false,
    message: '',
    section_names: []
  };


  componentDidMount() {
    this.setAllModel();
  }

  setAllModel() {
    let context = this;
    var x = [];
    let menu = ['Active', 'Inactive'];
    menu.map((y) => {
      x.push({key: y, text: y, value: y});
    });
    try {
      context.setState({
        section_names: x,
      });
    } catch (e) {}
  }

  onChange = (type) => (e, {value}) => {
    this.setState({
      [type]: value
    })
  }

  status = (f, { value }) => {
    this.setState({ status: value })
  }

  cancel() {
    this.props.handleClose();
  }

  update() {
    let context = this;
    context.setState({
      load: true,
      message: 'Updating Model Details'
    });
    let section_name = this.state.section_name;
    let tamil_name = this.state.tamil_name;
    let status = this.state.status;
    let id = this.state.id;
    let oldData = this.state.data;
    let priority = this.state.priority;

    if (section_name == '' || section_name == null || section_name == undefined) {
      context.setState({
        error: 'Enter Model name field!!!',
      });
      return;
    }

    if (tamil_name == '' || tamil_name == null || tamil_name == undefined) {
      context.setState({
        error: 'Enter Tamil name field!!!',
      });
      return;
    }

    if (priority == '' || priority == null || priority == undefined) {
      context.setState({
        error: 'Enter Priority field!!!',
      });
      return;
    }

    let data1 = { 'section_name': section_name, 'status': status, 'id': id, 'tamil_name': tamil_name, 'priority': priority };

    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'addmenu/sectiondetails/update.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        if (data == 1) {
          for (var i = 0; i < oldData.length; i++) {
            if (id == oldData[i].id) {
              oldData[i].section_name = section_name;
              oldData[i].status = status;
              oldData[i].tamil_name = tamil_name;
              oldData[i].priority = priority;
            }
          }
          context.props.updateData(oldData);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  render() {
    let { load, message, section_names, status, tamil_name } = this.state;
    return (
      <div>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Group Name<br/>
            <Input focus value={this.state.section_name}
                onChange={this.onChange('section_name')}
                placeholder='Group Name' style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Tamil Name<br/>
            <Input focus value={this.state.tamil_name}
                onChange={this.onChange('tamil_name')}
                placeholder='Tamil Name' style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Status<br/>
            <Dropdown style={{ borderColor: '#5A9CBB' }}
             fluid selection onChange={this.status}
             options={section_names} value={status} />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            Priority<br/>
            <Input focus value={this.state.priority}
                onChange={this.onChange('priority')}
                placeholder='Priority' style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button fluid onClick={this.cancel.bind(this)}>Cancel</Button>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button fluid onClick={this.update.bind(this)}>Save</Button>
          </Grid.Column>
        </Grid>
        <Loading load={load} message={message} />
      </div>
    );
  }
}

export default Edit;
